import React, { Component, useEffect, useState } from 'react';
import { isHebrew } from '../../../App';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@material-ui/core';
import Marquee from 'react-easy-marquee';

const useStyles = makeStyles((theme) => ({}));

const images = [
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Fbeach_bum.png?alt=media&token=9d61c11b-baca-4038-b9b3-70a4463fb82b',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Fcloud_plus.png?alt=media&token=9fd59e41-2208-48a1-a69c-fdb8c1d79539',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Feasy_morg.png?alt=media&token=83b17302-ea3d-40cc-9441-b3627e24130b',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Fgoogle.png?alt=media&token=bd9ed938-1aa7-4933-97ed-812127ae036e',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Fkipi.png?alt=media&token=8336f053-b0da-4f8e-a7f9-1538bc62f51b',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Flumenis.png?alt=media&token=30ae2050-5f9c-4dca-91b6-27ccfc9e6dfc',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Fmedia_force.png?alt=media&token=34de789a-b792-4a17-868a-73106fe11671',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Fpinook.png?alt=media&token=929b68f6-7bff-496b-9789-c18ceaf11d0c',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Ftau_uni.png?alt=media&token=eae38520-b0d1-49e0-ae8d-a1f2cf92940c',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Ftulip.png?alt=media&token=673ef73b-0359-4c1a-a466-f7d29326055b',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Fveritas.png?alt=media&token=4a7b0775-6187-44c6-9f6e-6b53b4429b07',
  'https://firebasestorage.googleapis.com/v0/b/celebrate-io.appspot.com/o/biz-landing-page%2Ffacebook.png?alt=media&token=5e588011-d06c-4e27-b1a6-86de46c430a6',
];

export const CustomersSection = () => {
  return (
    <Box position="relative" height="100px">
      <Box position="absolute" width="100vw" top={0} left={0}>
        <Marquee duration={30000} background="none" height="100px">
          {images.map((image) => (
            <Box p={1}>
              <img
                src={image}
                alt="picsum"
                style={{ height: '40px', width: 'auto', objectFit: 'contain' }}
              />
            </Box>
          ))}
        </Marquee>
      </Box>
    </Box>
  );
};
